import { usePunditUserContext } from "@/react/contexts";

export const useIsConnectSettingsEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.connect_settings_enabled);
};
